'use client';

import { useFlags } from '@lib/flags/amplitude/client';
import { FEATURE_FLAG_ON, Flags } from '@lib/flags/flagConstants';
import { usePathname } from 'next/navigation';
import { UpmProductDetailTemplate } from 'ui-components';
import { CommerceCartProvider } from './CommerceCartProvider';
import { UpmProductDetailPageProps } from './types';
import { useUpmProductDetailPage } from './useUpmProductDetailPage';

const UpmProductDetailPageInner = ({
  microcopy,
  ...initialData
}: UpmProductDetailPageProps) => {
  const { data, actions } = useUpmProductDetailPage(initialData);

  return (
    <UpmProductDetailTemplate
      {...data}
      microcopy={microcopy}
      {...actions}
      className="container"
    />
  );
};

export const UpmProductDetailPage = (props: UpmProductDetailPageProps) => {
  const { flags } = useFlags();
  const pathname = usePathname();
  const isPaidUpmEnabled = flags?.[Flags.PAID_UPM]?.value === FEATURE_FLAG_ON;

  if (!isPaidUpmEnabled || !props.productSku) {
    return <UpmProductDetailPageInner {...props} />;
  }

  return (
    <CommerceCartProvider returnToCartUrl={pathname ?? ''}>
      <UpmProductDetailPageInner {...props} />
    </CommerceCartProvider>
  );
};
